var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 33.3359V0.664062H0.664062V33.3359H33.3359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32813
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9805 11.953C21.9805 14.7036 19.7506 16.9334 17 16.9334C14.2494 16.9334 12.0195 14.7036 12.0195 11.953C12.0195 9.20234 14.2494 6.97248 17 6.97248C19.7506 6.97248 21.9805 9.20234 21.9805 11.953Z",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 33.0371C17 33.0371 6.043 19.9219 6.043 11.9531C6.043 5.91142 10.9583 0.996094 17 0.996094C23.0417 0.996094 27.9571 5.91142 27.9571 11.9531C27.9571 19.9219 17 33.0371 17 33.0371Z",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9335V18.9257",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0274 11.9531H12.0196",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4.9805V6.97269",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9805 11.9531H23.9727",
    stroke: "#43BC33",
    strokeWidth: 2.04001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceicon);
export default __webpack_public_path__ + "static/media/resourceicon.7780ee4202230b8f9ebea613a3208142.svg";
export { ForwardRef as ReactComponent };